import { type ColumnType, type Selectable } from 'kysely'
import { z } from 'zod'

import { legacySiteId, type LegacySiteId } from './LegacySite.js'
import { organizationId, type OrganizationId } from './Organization.js'
import { projectId, type ProjectId } from './Project.js'
import { sitePageTypeId, type SitePageTypeId } from './SitePageType.js'
import {
  siteStatusType,
  type default as SiteStatusType,
} from './SiteStatusType.js'

/** Represents the view public.site_menu_view_ */
export default interface SiteMenuViewTable {
  /** Database type: pg_catalog.int4 */
  id: ColumnType<LegacySiteId, never, never>

  /** Database type: pg_catalog.text */
  siteName: ColumnType<string, never, never>

  /** Database type: pg_catalog.bool */
  visible: ColumnType<boolean | null, never, never>

  /** Database type: public.site_status_type_ */
  status: ColumnType<SiteStatusType | null, never, never>

  /** Database type: pg_catalog.int4 */
  sortOrder: ColumnType<number | null, never, never>

  /** Database type: pg_catalog.int4 */
  projectId: ColumnType<ProjectId, never, never>

  /** Database type: pg_catalog.text */
  projectName: ColumnType<string, never, never>

  /** Database type: pg_catalog.int4 */
  organizationId: ColumnType<OrganizationId, never, never>

  /** Database type: pg_catalog.text */
  organizationName: ColumnType<string, never, never>

  /** Database type: pg_catalog.text */
  pageType: ColumnType<SitePageTypeId, never, never>
}

export type SiteMenuView = Selectable<SiteMenuViewTable>

export const siteMenuView = z.object({
  id: legacySiteId,
  siteName: z.string(),
  visible: z.boolean().nullable().optional(),
  status: siteStatusType.nullable().optional(),
  sortOrder: z.number().nullable().optional(),
  projectId: projectId,
  projectName: z.string(),
  organizationId: organizationId,
  organizationName: z.string(),
  pageType: sitePageTypeId,
}) as unknown as z.Schema<SiteMenuView>
